import { useQuery } from 'react-query';
import { QUERY_KEYS_SERVICE_AGREEMENTS } from 'api/query-keys';
import { serviceAgreementsService } from 'ogp/services';

export const useGetServiceAgreementCompany = (serviceAgreementId: string) => {
  return useQuery(
    [...QUERY_KEYS_SERVICE_AGREEMENTS.detail(serviceAgreementId), 'company'],
    async () => await serviceAgreementsService.getCompanyByServiceAgreementId(serviceAgreementId)
  );
};
